<ng-container *ngrxLet="{ cylinderLabelsTemplate: cylinderLabelsTemplate$ } as vm">
    <dtm-map-html-cesium-component
        *ngFor="let label of cylinderLabels$ | ngrxPush; trackBy: trackByEntityId"
        [coordinates]="label.position"
        [shouldHideOccluded]="false"
        [shouldHideOutOfView]="false"
    >
        <ng-container *ngIf="vm.cylinderLabelsTemplate; else simpleLabelsTemplate">
            <ng-container *ngTemplateOutlet="vm.cylinderLabelsTemplate; context: { $implicit: label }"></ng-container>
        </ng-container>
        <ng-template #simpleLabelsTemplate>
            <span class="default-label">{{ label.text }}</span>
        </ng-template>
    </dtm-map-html-cesium-component>
</ng-container>
